import { render, staticRenderFns } from "./FlightLazyLoad.vue?vue&type=template&id=67aa035d&scoped=true"
import script from "./FlightLazyLoad.vue?vue&type=script&lang=js"
export * from "./FlightLazyLoad.vue?vue&type=script&lang=js"
import style0 from "./FlightLazyLoad.vue?vue&type=style&index=0&id=67aa035d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67aa035d",
  null
  
)

export default component.exports